<script>
import { api } from '../../../firebase'

export default {
  name: 'MobilizeV2CreateTextTemplate',
  data() {
    return {
      form: {
        data: {
          name: null,
          headline: null,
          body: null,
          linkDescription: null
        },
        submitState: {
          pending: false,
          done: false,
          error: null
        }
      }
    }
  },
  methods: {
    async submitForm() {
      this.form.submitState.pending = true
      this.form.submitState.done = false
      this.form.submitState.error = null
      try {
        const response = await api.textTemplates.create({
          name: this.form.data.name,
          headline: this.form.data.headline,
          body: this.form.data.body,
          linkDescription: this.form.data.linkDescription,
          enabled: true
        })
        this.form.submitState.done = true
        this.$toast.success('Text template created successfully')
        return response
      } catch (error) {
        this.form.submitState.error = error
        this.$toast.error('Text template creation failed')
      } finally {
        this.form.submitState.pending = false
      }
    },
    resetForm() {
      this.form = {
        submitState: {
          pending: false,
          done: false,
          error: null
        },
        data: {
          name: null,
          headline: null,
          body: null,
          linkDescription: null
        }
      }
    },
    async onCreateButtonClick() {
      const response = await this.submitForm()
      if (this.form.submitState.error) {
        return
      }
      const { id } = response
      this.$router.push(`/mobilizev2/text-templates/${id}`)
    },
    async onCreateAndAddAnotherButtonClick() {
      await this.submitForm()
      if (this.form.submitState.error) {
        return
      }
      this.resetForm()
    },
    async onResetButtonClick() {
      this.resetForm()
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view">
    <h1>Create a Text Template</h1>
    <v-form>
      <v-text-field label="Name" placeholder="Name" :disabled="form.submitState.pending" v-model="form.data.name" />
      <v-text-field label="Headline" placeholder="Headline" :disabled="form.submitState.pending" v-model="form.data.headline" />
      <v-textarea no-resize rows="12" label="Body" plcaeholder="Body" :disabled="form.submitState.pending" v-model="form.data.body" />
      <v-text-field label="Link Description" placeholder="Link Description" :disabled="form.submitState.pending" v-model="form.data.linkDescription" />
      <v-alert class="block" v-if="form.submitState.error">
        <p>{{ form.submitState.error.message }}</p>
      </v-alert>
      <div class="d-flex flex-row-reverse">
        <v-btn
          color="primary"
          class="mini-hidden mx-1 ml-0"
          :disabled="form.submitState.pending"
          @click="onCreateButtonClick"
        >
          <v-icon left dark>add</v-icon>
          Create
        </v-btn>
        <v-btn
          color="primary"
          class="mini-hidden mx-1"
          :disabled="form.submitState.pending"
          @click="onCreateAndAddAnotherButtonClick"
        >
          <v-icon left dark>add</v-icon>
          Create &amp; add another
        </v-btn>
        <v-btn
          color="light-grey"
          class="mini-hidden mx-1"
          :disabled="form.submitState.pending"
          @click="onResetButtonClick"
        >
          <v-icon left dark>undo</v-icon>
          Reset
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.block {
  display: block;
}

.my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.preview {
  max-height: 600px;
  max-width: 100%;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  width: 600px;
  height: 600px;
}
</style>
